import React from 'react';
import { formatMoney } from '../../../../utils/numberFormatting';

const TableHeader = () => (
    <tr>
        <th className="text-left py-4 px-4 text-sm font-medium text-slate-400 border-b border-slate-800">
            Win Rate
        </th>
        <th className="text-right py-4 px-4 text-sm font-medium text-slate-400 border-b border-slate-800">
            R per Trade
        </th>
        <th className="text-right py-4 px-4 text-sm font-medium text-slate-400 border-b border-slate-800">
            Profit Factor
        </th>
        <th className="text-right py-4 px-4 text-sm font-medium text-slate-400 border-b border-slate-800">
            Total R
        </th>
        <th className="text-right py-4 px-4 text-sm font-medium text-slate-400 border-b border-slate-800">
            Max Loss Streak
        </th>
        <th className="text-right py-4 px-4 text-sm font-medium text-slate-400 border-b border-slate-800">
            Expected Return
        </th>
    </tr>
);

const LoadingRow = () => (
    <tr className="animate-pulse">
        <td colSpan={6} className="py-4 px-4">
            <div className="h-6 bg-slate-800 rounded" />
        </td>
    </tr>
);

const TableRow = ({ data, isBreakEven, isCurrentRate }) => {
    const {
        rate,
        expectancy,
        profitFactor,
        totalR,
        maxLossStreak,
        totalMoney
    } = data;

    return (
        <tr className={`
            ${isBreakEven ? 'bg-slate-800/40' : ''}
            ${isCurrentRate ? 'bg-primary-orange/5 border-l-2 border-l-primary-orange' : ''}
            hover:bg-slate-800/60
            transition-colors
        `}>
            <td className="py-4 px-4 text-sm text-slate-300/90">
                {isBreakEven ? 'Break-even: ' : ''}
                {rate.toFixed(isBreakEven ? 2 : 1)}%
            </td>
            <td className="text-right py-4 px-4 text-sm text-slate-300/90">
                {expectancy > 0 ? '+' : ''}{expectancy}R
            </td>
            <td className="text-right py-4 px-4 text-sm text-slate-300/90">
                {profitFactor}
            </td>
            <td className="text-right py-4 px-4 text-sm text-slate-300/90">
                {totalR > 0 ? '+' : ''}{totalR}R
            </td>
            <td className="text-right py-4 px-4 text-sm text-slate-300/90">
                {maxLossStreak.toLocaleString()} trades
            </td>
            <td className="text-right py-4 px-4 text-sm">
                <span className={`
                    ${Number(totalMoney) > 0 ? 'text-emerald-500' : 'text-rose-400'}
                    ${Number(totalMoney) === 0 ? 'text-slate-400' : ''}
                `}>
                    {formatMoney(totalMoney, true)}
                </span>
            </td>
        </tr>
    );
};

const MatrixTable = ({
    winRates,
    breakEvenRate,
    currentWinRate,
    totalTrades,
    getStatsForRate,
    isLoading = false
}) => {
    return (
        <div className="relative overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                    <thead>
                        <TableHeader />
                    </thead>
                    <tbody>
                        {isLoading ? (
                            [...Array(10)].map((_, index) => (
                                <LoadingRow key={index} />
                            ))
                        ) : (
                            Array.isArray(winRates) && winRates.map(rate => (
                                <TableRow
                                    key={rate}
                                    data={{
                                        rate,
                                        ...getStatsForRate(rate)
                                    }}
                                    isBreakEven={Math.abs(rate - breakEvenRate) < 0.1}
                                    isCurrentRate={Math.abs(rate - currentWinRate) < 0.1}
                                />
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MatrixTable;